import { addToChainAfter, makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { getSession as getSessionApi, UpdateSessionApiParameter, updateSessionWithResult, UpdateSessionWithResultApiParameter } from "@insite/client-framework/Services/SessionService";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { chain, DispatchCompleteSignIn } from "@insite/client-framework/Store/Context/Handlers/SignIn";
import clearCurrentCart from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import { BillToModel, SessionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { productPriceStyles } from "@insite/content-library/Components/ProductPrice";

// Load property type by checking parameters of an existing chain step
type extendSignInProps = Parameters<typeof DispatchCompleteSignIn>[0];

// Custom function to be injected
function resetCart(props: extendSignInProps) {
    // Dispatch call to chain handlers
    props.dispatch(clearCurrentCart());
}

const defaultCustomer = async (props: extendSignInProps) => {
    const currentSession = props.authenticatedSession;

    if (currentSession
            && currentSession?.billToId 
            && !currentSession?.hasDefaultCustomer) {
        const sessionParameters: UpdateSessionApiParameter = {
            session: {
                customerWasUpdated: false,
                shipToId: currentSession?.shipToId,
                billToId: currentSession?.billToId,
                fulfillmentMethod: currentSession.fulfillmentMethod,
                pickUpWarehouse: currentSession.pickUpWarehouse,
            }
        };
        const newApiParameter: UpdateSessionWithResultApiParameter = { ...sessionParameters };
        newApiParameter.session.billTo = {
            id: currentSession?.billToId,
            isDefault: true,
        } as BillToModel;
        if (currentSession?.shipToId !== undefined) {
            newApiParameter.session.shipTo = { id: currentSession?.shipToId } as ShipToModel;
        }
    
        const result = await updateSessionWithResult(newApiParameter);
        let sessionModel: SessionModel;
        if (result.successful) {
            sessionModel = await getSessionApi({});
        } else {
            props.parameter.onError?.(result.errorMessage);
            return false;
        }
    }
}

// Hook in to chain
addToChainAfter(chain, DispatchCompleteSignIn, resetCart);
addToChainAfter(chain, DispatchCompleteSignIn, defaultCustomer);